import { useAbExperimentBucket } from '#/hooks/abExperiment/useAbExperimentBucket';

export function useIsMobileSearchV2Enabled(): boolean {
  return useAbExperimentBucket('MOBILE_SEARCH_V2_B_2026_06') === 'ENABLED';
}
